import { useEffect, useState } from "react";

export function useIsMobile(breakpoint = 768) {
    const query = `(max-width: ${breakpoint - 1}px)`;

    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === "undefined" || !window.matchMedia) return false;
        return window.matchMedia(query).matches;
    });

    useEffect(() => {
        if (typeof window === "undefined" || !window.matchMedia) return undefined;
        const mql = window.matchMedia(query);
        const handler = (e) => setIsMobile(e.matches);
        setIsMobile(mql.matches);
        if (mql.addEventListener) {
            mql.addEventListener("change", handler);
            return () => mql.removeEventListener("change", handler);
        }
        mql.addListener(handler);
        return () => mql.removeListener(handler);
    }, [query]);

    return isMobile;
}

export default useIsMobile;
